import { useEffect } from "react";
import { scrollToInitialHash } from "../../utils/scrollToSection";

/** Handles direct links like https://yoursite.com/#contact on first paint. */
const HashScrollHandler = () => {
  useEffect(() => {
    if (!window.location.hash) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      scrollToInitialHash({ behavior: "auto" });
    }, 100);

    return () => window.clearTimeout(timer);
  }, []);

  return null;
};

export default HashScrollHandler;
